import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { AnalyticsEvents } from '@sdk/analytics/types';

import ExclamationYellow from '@web/assets/svg/Icons/48/announcement-yellow.svg';
import ExclamationRed from '@web/assets/svg/Icons/48/announcement-red.svg';
import CancelRed from '@web/assets/svg/Icons/48/cancel-red.svg';
import { WarningType } from '@web/account/billingWarnings/ExpiryWarningModal/expiryWarningModal.types';

export const iconMap = {
  [WarningType.cardExpiringSoon]: <ExclamationYellow />,
  [WarningType.cardExpired]: <ExclamationRed />,
  [WarningType.paymentFailed]: <CancelRed />,
  [WarningType.cardAuthenticationFailed]: <CancelRed />,
  [WarningType.accountLocked]: <CancelRed />,
};

export const titleMap = {
  [WarningType.cardExpiringSoon]: gettext('Your credit card expires soon'),
  [WarningType.cardExpired]: gettext('Your credit card has expired'),
  [WarningType.paymentFailed]: gettext('Your payment has failed'),
  [WarningType.cardAuthenticationFailed]: gettext('Your payment has failed'),
  [WarningType.accountLocked]: gettext('Your subscription has been paused'),
};

export const descriptionMap = {
  [WarningType.cardExpiringSoon]: (lastFour: string) =>
    gettext(
      'Your credit card ending in %(lastFour)s is going to expire soon. To keep your subscription active, please update your payment details in the next 7 days.',
      { lastFour }
    ),
  [WarningType.cardExpired]: (lastFour: string) =>
    gettext(
      'Your credit card ending in %(lastFour)s has now expired. To keep your subscription active, please update your payment details in the next 7 days.',
      { lastFour }
    ),
  [WarningType.accountLocked]: () =>
    gettext(
      'We tried to charge your credit card a few times without success, and had to temporarily pause your subscription. To restart it, please update your payment details.'
    ),
  [WarningType.paymentFailed]: () =>
    gettext(
      "We tried to charge your credit card, but can't get your payment working. To keep your subscription active, please update your payment details in the next 7 days."
    ),
  [WarningType.cardAuthenticationFailed]: () =>
    gettext(
      "We tried to charge your credit card, but can't get your payment working. To keep your subscription active, retry payment now."
    ),
};

export const titleColorMap = {
  [WarningType.cardExpiringSoon]: ThemeColorType.warning,
  [WarningType.cardExpired]: ThemeColorType.danger,
  [WarningType.accountLocked]: ThemeColorType.danger,
  [WarningType.paymentFailed]: ThemeColorType.danger,
  [WarningType.cardAuthenticationFailed]: ThemeColorType.danger,
};

export const analyticsEvent = {
  [WarningType.cardExpiringSoon]: AnalyticsEvents.ccExpiringReminderShown,
  [WarningType.cardExpired]: AnalyticsEvents.ccExpiredWarningShown,
  [WarningType.accountLocked]: AnalyticsEvents.subscriptionPausedShown,
  [WarningType.paymentFailed]: AnalyticsEvents.insufficientFundsWarningShown,
  [WarningType.cardAuthenticationFailed]: null,
};

const updateNowText = gettext('Update now');

export const buttonTextMap = {
  [WarningType.cardExpiringSoon]: updateNowText,
  [WarningType.cardExpired]: updateNowText,
  [WarningType.accountLocked]: updateNowText,
  [WarningType.paymentFailed]: updateNowText,
  [WarningType.cardAuthenticationFailed]: gettext('Retry payment'),
};
